/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { store } from 'core/store';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { notificationConstants } from '../../../modules/notifications/notifications';
import InputFormRest from '../../../components/Form/InputFormRest';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import CancelTextButton from '../../../components/Buttons/CancelTextButtons';
import { clientAddressesReducers } from '../../../modules/clients/adresses/reducers';
import { clientAddressEntity, clientAddressEntityStatus } from '../../../modules/clients/adresses/EntityAddress';
import { clientAddressesActions, clientAddressesConstants } from '../../../modules/clients/adresses/actions';

class ClientAddressEdit extends Component {
    constructor(props) {
        super(props);

        store.injectReducer('clientAddressesReducers', clientAddressesReducers);

        this.state = {
            addressType: props.addressType,
            clientId: props.clientId,
            isNew: false,
            filter: [
                { name: 'clientId', value: props.clientId },
                { name: 'type', value: props.addressType },
            ],
            order: [],
            addressCollections: null,
            addressData: null,
            entity: null,
            entityStatus: clientAddressEntityStatus,
        };

        this.initial();
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    initial = () => {
        const { dispatch } = this.props;
        dispatch(
            clientAddressesActions.getList(
                FormGeneralHelper.getUrl('/client_addresses'),
                this.state.filter,
                this.state.order,
                clientAddressesConstants.CLIENT_ADDRESS_LIST
            )
        );
    };

    notifyInfo = (message, variant) => {
        const { dispatch } = this.props;
        dispatch({
            ...this.state,
            type: notificationConstants.CUSTOM_NOTIFY,
            message: message,
            variant: variant,
        });
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.addressCollections && this.state.addressCollections === null) {
            this.setState({
                addressCollections: nextProps.addressCollections,
                isNew: !(nextProps.addressCollections && nextProps.addressCollections['hydra:totalItems'] > 0),
                entity:
                    nextProps.addressCollections && nextProps.addressCollections['hydra:totalItems'] > 0
                        ? nextProps.addressCollections['hydra:member'][0]
                        : clientAddressEntity,
            });
            return false;
        }

        if (nextProps.addressData && this.state.addressData === null && nextProps.success) {
            this.notifyInfo('general:common.changes_saved', 'success');
            return false;
        }

        return true;
    }

    saveElement = () => {
        const { dispatch } = this.props;
        const entity = this.state.entity;

        if (this.state.isNew) {
            entity.type = this.state.addressType;
            entity.clientId = this.state.clientId;
        }

        if (this.state.isNew) {
            dispatch(clientAddressesActions.post(FormGeneralHelper.getUrl('/client_addresses'), entity, clientAddressesConstants.CLIENT_ADDRESS_ADD));
        } else {
            dispatch(clientAddressesActions.put(FormGeneralHelper.getByUri(entity['@id']), entity, clientAddressesConstants.CLIENT_ADDRESS_EDIT));
        }
    };

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    render() {
        const { entity, entityStatus } = this.state;
        const { callBackClose, classes } = this.props;
        if (entity) {
            const xs = 12;
            const md = 12;
            const lg = 6;

            return (
                <form onSubmit={this.handleSubmit} key="client_addresses_form">
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="firstname"
                                        stateObjectState={entityStatus.firstname}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.firstname"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.firstname}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="mainname"
                                        stateObjectState={entityStatus.mainname}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.name"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.mainname}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="street"
                                        stateObjectState={entityStatus.street}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.street"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.street}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={6} lg={3}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="house"
                                        stateObjectState={entityStatus.house}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.house"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.house}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={6} lg={3}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="apartment"
                                        stateObjectState={entityStatus.apartment}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.apartment"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.apartment}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="zip"
                                        stateObjectState={entityStatus.zip}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.zip_code_00_000"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.zip}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="city"
                                        stateObjectState={entityStatus.city}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.city"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.city}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="state"
                                        stateObjectState={entityStatus.state}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.state"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.state}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="country"
                                        stateObjectState={entityStatus.country}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.country"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.country}
                                    />
                                </GridItem>
                                <GridItem xs={xs} md={md} lg={lg}>
                                    <InputFormRest
                                        classes={classes}
                                        callback={this.change}
                                        stateName="nip"
                                        stateObjectState={entityStatus.nip}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName="clients:c.nip"
                                        vMax={256}
                                        vMin={-1}
                                        required={false}
                                        value={entity.nip}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            {this.props.closeable && this.props.closeable === true && <CancelTextButton callback={callBackClose} />}
                        </GridItem>
                    </GridContainer>
                </form>
            );
        } else {
            return <div>Loading...</div>;
        }
    }
}

ClientAddressEdit.propTypes = {
    classes: PropTypes.object.isRequired,
    clientId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
    const { clientAddressesReducers } = state;
    if (clientAddressesReducers === undefined) {
        return { ...state };
    }

    let addressCollections = null;
    let addressData = null;
    let success = false;

    if (clientAddressesReducers) {
        if (clientAddressesReducers.addressData) {
            addressData = clientAddressesReducers.addressData;
        }
        if (clientAddressesReducers.success) {
            success = clientAddressesReducers.success;
        }
        if (clientAddressesReducers.addressCollections) {
            addressCollections = clientAddressesReducers.addressCollections;
        }
    }
    return {
        success: success,
        addressData: addressData,
        addressCollections: addressCollections,
    };
};

const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(ClientAddressEdit);
export default Enhance;
